//= require trackjs.js

if (typeof window.global_config === 'undefined') {
  window.global_config = {
    feature_flags: {},
    settings: {},
  }
}
